import { $post, $download } from '@/api/request'
// 新增模板
export function addTemp (data) {
  return $post({
    url: '/templateInfo/add',
    data
  })
}
// 更新模板
export function updateTemp (data) {
  return $post({
    url: '/templateInfo/update',
    data
  })
}
// 查询模板
export function tempQuery (data) {
  return $post({
    url: '/templateInfo/query',
    data
  })
}
// 编辑模板
export function editTemp (data) {
  return $post({
    url: '/templateInfo/queryById',
    data
  })
}
// 删除模板
export function deleteTemp (data) {
  return $post({
    url: '/templateInfo/deleteById',
    data
  })
}
// 下载模板
export function downloadTemp (data) {
  return $download({
    url: '/templateInfo/downloadTemplatePdf',
    data
  })
}
// 保存合同信息
export function addContractInfo (data) {
  return $post({
    url: '/contractInfo/add',
    data
  })
}
// 更新合同信息
export function updateContractInfo (data) {
  return $post({
    url: '/contractInfo/update',
    data
  })
}
// 提交审批
export function addContractApprove (data) {
  return $post({
    url: '/contractProcess/add',
    data
  })
}
// 查询合同
export function contractQuery (data) {
  return $post({
    url: '/contractInfo/queryByPage',
    data
  })
}
// 删除合同
export function deleteContractInfo (data) {
  return $post({
    url: '/contractInfo/deleteById',
    data
  })
}
// 上传文件（归档）
export function fileUpload (data) {
  return $post({
    url: '/minio/contractFiling',
    data
  })
}
// 预览合同接口
export function previewContractDetail (data) {
  return $post({
    url: '/contractInfo/previewContractDetail',
    data
  })
}
// 查看单条合同信息详情
export function queryContractDetail (data) {
  return $post({
    url: '/contractInfo/queryById',
    data
  })
}
// 打印接口
export function addPrint (data) {
  return $post({
    url: '/contractPrint/add',
    data
  })
}
// 查询归档历史
export function filingHistory (data) {
  return $post({
    url: '/contractFiling/queryPageByContractNum',
    data
  })
}

// 上传归档文件
export function addContractHistory (data) {
  return $post({
    url: '/contractFiling/add',
    data
  })
}
// 上传归档文件
export function uploadContractHistory (data) {
  return $post({
    url: '/contractHistoryFiling/uploadContractHistory',
    data
  })
}

// 查询归档文件
export function queryContractHistory (data) {
  return $post({
    url: '/contractFiling/queryByPage',
    data
  })
}

// 删除合同归档
export function deleteContractHistory (data) {
  return $post({
    url: '/contractFiling/deleteById',
    data
  })
}

// 税务管理 新增 修改 删除  查看
export function baseVoucher(portType, data) {
  return $post({
    url: `/baseVoucher/${portType}`,
    data
  })
}
